import { VideoSettings as VideoSettingsModule } from "../modules/VideoSettings/VideoSettings";

const VideoSettings = () => {
  return <VideoSettingsModule />;
};

export default VideoSettings;
